export default "__VITE_ASSET__093cac96__"